define('GoferParts.Main.View', [
  'Backbone',
  'PageType.Base.View',
  'Facets.FacetedNavigation.View',
  'Facets.Model',
  'Facets.Helper',
  'GlobalViews.Pagination.View',
  'GlobalViews.ShowingCurrent.View',
  'ShopByModel.Thumbnail.View',
  'ShopByModel.Model',
  'GoferParts.Collection.View',
  'GoferParts.Documents.View',
  'GoferParts.Diagrams.View',
  'Item.Collection',
  'gofer_parts_by_model.tpl',
  'ListHeader.View',
  'Utils',
  'underscore',
  'jQuery'
], function (
  Backbone,
  PageTypeBaseView,
  FacetsFacetedNavigationView,
  FacetsModel,
  FacetsHelper,
  GlobalViewsPaginationView,
  GlobalViewsShowingCurrentView,
  GoferModelThumbnailView,
  GoferModelModel,
  GoferPartsCollectionView,
  GoferPartsDocumentsView,
  GoferPartsDiagramsView,
  ItemCollection,
  gofer_parts_by_model_tpl,
  ListHeaderView,
  Utils,
  _,
  jQuery
) {
  'use strict';

  return Backbone.View.extend({
    template: gofer_parts_by_model_tpl,

    initialize: function ( options ) {
      try {
        this.application = {};
        //this.model = new FacetsModel();
        this.model = options.model;
        this.goferModel = new GoferModelModel();
        this.goferModelData = {};
        this.goferModelParts = [];
        this.goferModelResources = {};
        this.goferModelDiagramPages = [];
        this.show = 'parts';

        // this.displayBreadcrumb();

        var page = '1';

        if ( this.options.routerArguments && this.options.routerArguments[1] ) {
            var params = Utils.parseUrlOptions( this.options.routerArguments[1] );

            if (params.page) {
                page = params.page.toString();
            }
        }

        this.options.page = page;
        this.model.on('change', this.setupListHeader, this);

        if ( page == 1 ) {
          this.removeCategory();
        }
      } catch (err) {
        console.error(452093, err);
      }
    },

    events: {
      'click [data-action="add-category"]': 'addCategory',
      'click [data-action="remove-category"]': 'removeCategory'
    },

    displayBreadcrumb: function () {
      var placeholder = jQuery('.shopping-layout-breadcrumb');

      if (placeholder.is(':hidden')) {
        placeholder.show();
      }
    },

    getBreadcrumbPages: function () {
      var routerArgs = this.options.routerArguments;
      var breadcrumbs = [
        {
          text: Utils.translate('Shop by Models'),
          href: 'shop-by-model'
        },
        {
          text: _.first(routerArgs),
          href: Backbone.history.getFragment()
        }
      ];

      return breadcrumbs;
    },

    removeCategory: function (e) {
      //e.preventDefault();
      //e.stopPropagation();

      var self = this;
      var goferModelFacetUrl = '';

      this.args = this.parseArgs();

      this.getParsedFacetName(this.args.modelName).done(function (result) {
        goferModelFacetUrl = result.model;
      });

      delete this.activeCategory;

      // Clear facet options
      this.model.options = {};
      this.model.set('partscategory', '');
      this.model.set('partscategoryid', '');
      window.history.replaceState({}, document.title, "");

      this.model
        .fetch({
          data: {
            custitem_mhi_gfr_model: goferModelFacetUrl
          }
        })
        .done(function (results) {
          self.goferModelParts = results.items;
          self.render();
        });
    },

    addCategory: function (e) {
      e.preventDefault();
      e.stopPropagation();

      var self = this;
      var goferModelFacetUrl = '';

      this.getParsedFacetName(this.args.modelName).done(function (result) {
        goferModelFacetUrl = result.model;
      });

      var category = _.find(_.first(SC.CATEGORIES).categories, function (category) {
        return category.internalid == e.target.getAttribute('category');
      });

      if (category) {
        self.activeCategory = category.internalid;
      }

      // Set Parts Commerce Category when selected from the Facet Navigation
      this.model.set('partscategory', category.fullurl);
      this.model.set('partscategoryid', e.target.getAttribute('category'));

      // Clear options after every category selection
      this.model.options = {};
      if ( this.options.routerArguments && this.options.routerArguments[1] ) {
        this.options.routerArguments[1]
      }

      this.model
        .fetch({
          data: {
            custitem_mhi_gfr_model: goferModelFacetUrl,
            commercecategoryurl: category.fullurl
          }
        })
        .done(function (results) {
          self.goferModelParts = results.items;
          self.render();
        });
    },

    beforeShowContent: function () {
      try {
        this.application = this.options.application;
        this.args = this.parseArgs();
        this.show = this.args.page;
        this.translator = FacetsHelper.parseUrl(
          Backbone.history.fragment,
          this.application.translatorConfig,
          false
        );

        var self = this;
        var deferred = jQuery.Deferred();
        var goferModelFacetUrl = '';
        var commercecategoryurl = this.model.get('partscategory');
        var commercecategoryid = this.model.get('partscategoryid');

        jQuery
          .when(
            // Get GoferModel facet url ( must be in proper format to use in itemsAPI req )
            this.getParsedFacetName(this.args.modelName).done(function (result) {
              goferModelFacetUrl = result.model;
            }),
            // Get GoferModel data
            this.goferModel
              .fetch({
                data: {
                  goferModel: encodeURIComponent(this.args.modelName)
                }
              })
              .done(function (results) {
                self.goferModelData = results;
                self.goferModelResources = results.resources;
                self.goferModelDiagramPages = results.diagramPages;
              })
          )
          .done(function () {
            // Only make API fetch if there will be a valid response
            if (goferModelFacetUrl) {
              var	urlOptions = _.parseUrlOptions(window.location.href);
              var page = self.options.page || (urlOptions && urlOptions.page);
              page = (page - 1) * 24;
              
              /* self.model.options = {
                data: self.translator.getApiParams()
              }; */

              if( !!commercecategoryurl ) {
                self.activeCategory = commercecategoryid;
                self.model.options = {
                  data: {
                    'commercecategoryurl': commercecategoryurl
                  }
                };
              }
              /* else  
              {
                var isLocal = Backbone.history.location.href.indexOf('-local.ssp') !== -1;
                var localPath = Backbone.history.location.hash;
                var path = Backbone.history.location.pathname;

                var partsUrl = isLocal ? path + localPath : localPath

                console.log('url', partsUrl);
                window.history.replaceState({}, document.title, "/" + partsUrl.split('?')[0]);
              } */
              
              self.model
                .fetch({
                  data: {
                    custitem_mhi_gfr_model: goferModelFacetUrl,
                    limit: 24,
                    offset: page
                  }
                })
                .done(function (results) {
                  self.goferModelParts = results.items;
                  deferred.resolve();
                });
            } else {
              // Show no results found message
              deferred.resolve();
            }
          });

        return deferred;
      } catch (err) {
        console.error(203992, err);
      }
    },

    parseArgs: function () {
      try {
        var routerArgs = this.options.routerArguments;
        var pages = ['documents', 'diagrams', 'videos', 'parts'];
        var args = { modelName: routerArgs[0], page: 'parts', params: {} };
        var paramParts = routerArgs[1];

        if (!paramParts) {
          return args;
        }

        paramParts.split('&').forEach(function (part) {
          var keyValue = part.split('=');
          var key = keyValue[0];
          args.params[key] = keyValue[1];
          if (pages.indexOf(key) != -1) {
            args.page = key;
          }
        });

        return args;
      } catch (err) {
        console.error(928784, err);
      }
    },

    setupListHeader: function () {
      this.listHeader = new ListHeaderView({
        view: this,
        application: this.options.application,
        collection: this.model.get('items'),
        sorts: this.sortOptions,
        page: this.options.page,
        hidePagination: true
      });
    },

    getPagination: function getPagination() {
      return {
        currentPage: this.translator.getOptionValue('page'),
        pageCount: this.totalPages,
        itemCount: this.model.get('total'),
        pageSize: parseInt(this.translator.getOptionValue('show'), 10),
        sorting: this.translator.getOptionValue('order'),
        display: this.translator.getOptionValue('display'),
        filters: this._getFacetsTranslator(this.translator),
        searchText: this.translator.getOptionValue('keywords')
      };
    },

    _getFacetsTranslator: function (translator) {
      var facets = {};
      var allFacets = translator.getAllFacets();

      _.each(allFacets, function (facet) {
        facets[facet.url] = facet.value;
      });

      return facets;
    },

    filterOptions: [],

    sortOptions: [],

    getParsedFacetName: function (modelName) {
      var deferred = jQuery.Deferred();
      var collection = new ItemCollection();
      var data = {
        fieldset: 'typeahead',
        include: 'facets',
        limit: 1
      };

      collection.fetch({ data: data }).done(function (res) {
        var parsed = {
          model: '',
          status: ''
        };

        var modelFacets = _.find(res.facets, function (facet) {
          return facet.id == 'custitem_mhi_gfr_model';
        });

        if (modelName) {
          _.each(modelFacets.values, function (facetValue) {
            if (modelName != facetValue.label) {
              return;
            }
            parsed.model = facetValue.url;
          });
        }

        if (!_.isEmpty(parsed)) {
          parsed.status = 'success';
          return deferred.resolve(parsed);
        }

        return deferred.resolve();
      });

      return deferred;
    },

    getChildViews: function () {
      return {
        'List.Header': function () {
          return this.listHeader;
        },
        'GoferParts.Collection.View': function () {
          return new GoferPartsCollectionView({
            collection: this.model.get('items'),
            application: this.options.application
          });
        },
        'ShopByModel.Thumbnail.View': function () {
          return new GoferModelThumbnailView({
            model: this.goferModel
          });
        },
        'GlobalViews.Pagination': function () {
          var self = this;
          var totalItems = this.model.get('total') || 0;
          return new GlobalViewsPaginationView(
            _.extend(
              {
                currentPage: this.translator.getOptionValue('page'),
                totalPages: Math.ceil(totalItems / 24),
                pager: function (page) {
                  return self.translator.cloneForOption('page', page).getUrl();
                }
              },
              this.options.application.getConfig().defaultPaginationSettings
            )
          );
        },
        'GlobalViews.ShowCurrentPage': function () {
          var totalItems = this.model.get('total') || 0;

          return new GlobalViewsShowingCurrentView({
            items_per_page: 24,
            total_items: totalItems,
            total_pages: Math.ceil(totalItems / 24),
            flag: true
          });
        },
        'GoferParts.Documents.View': function () {
          var resources = [];

          _.each(this.goferModelResources, function (value, key) {
            // Everything except Videos are considered 'Documents'
            if (key !== 'Videos') {
              resources = resources.concat(value.data);
            }
          });

          return new GoferPartsDocumentsView({
            application: this.application,
            model: this.model,
            resources: resources
          });
        },
        'GoferParts.Diagrams.View': function () {
          try {
            return new GoferPartsDiagramsView({
              application: this.application,
              args: this.args,
              pages: this.goferModelDiagramPages || []
            });
          } catch (err) {
            console.error(453923, err);
          }
        },
        'GoferParts.Videos.View': function () {
          var videos = this.goferModelResources.Videos || {};
          return new GoferPartsDocumentsView({
            application: this.application,
            model: this.model,
            resources: videos.data
          });
        },
        'Facets.FacetedNavigation': function (options) {
          var exclude = [
            'custitem_mhi_gfr_company',
            'custitem_mhi_gfr_model',
            'commercecategoryname',
            'custitem_mhi_ts_prod_category',
            'category'
          ];
          var hasCategories = !!(this.category && this.category.categories);
          var hasItems = this.model.get('items') && this.model.get('items').length;
          var hasFacets = hasItems && this.model.get('facets') && this.model.get('facets').length;
          var appliedFacets = this.translator.cloneWithoutFacetId('category').facets;
          var hasAppliedFacets = appliedFacets.length;
          var baseUrl = 'gofer-parts/';
          var modelUrl = this.options.routerArguments && this.options.routerArguments[0];
          var facets = _.filter(this.model.get('facets'), function (facet) {
            return !_.contains(exclude, facet.id);
          });

          return new FacetsFacetedNavigationView({
            clearAllFacetsLink: baseUrl + encodeURIComponent(modelUrl),
            hasCategories: hasCategories,
            hasItems: hasItems,
            hasFacets: hasFacets,
            hasCategoriesAndFacets: hasCategories && hasFacets,
            appliedFacets: appliedFacets,
            hasFacetsOrAppliedFacets: hasFacets || hasAppliedFacets,
            translator: this.translator,
            facets: facets,
            totalProducts: this.model.get('total'),
            keywords: this.translator.getOptionValue('keywords')
        });
        }
      };
    },

    getContext: function () {
      var environment = this.application.getComponent('Environment');
      var self = this;
      
      return {
        displayValues: _.map(_.first(SC.CATEGORIES).categories, function (category) {
          return {
            isActive: self.activeCategory && self.activeCategory == category.internalid,
            link: category.fullurl,
            label: category.name,
            displayName: category.name,
            categoryId: category.internalid
          };
        }),
        shopByModelContent: environment.getConfig('layout.shopByModel'),
        showDocuments: this.show == 'documents',
        showDiagrams: this.show == 'diagrams',
        showVideos: this.show == 'videos',
        showParts: this.show == 'parts',
        showPartsCollectionView: this.goferModelParts.length > 0,
        goferModelData: this.goferModelData,
        goferModelParts: this.goferModelParts
      };
    }
  });
});
